/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react'
import {AiFillLock} from 'react-icons/ai'
import {FiBookOpen, FiChevronLeft} from 'react-icons/fi'
import {VmoButton, VmoDivider, VmoRadio, VmoTooltip} from 'vmo-library'
import LockPermissionTooltip from 'components/common/LockPermissionTooltip'
import {featureAccessDeniedContent, roleAccessDeniedContent} from 'constants/variables'

const Page = props => {
  const {
    header,
    learnMoreUrl = '',
    subHeader,
    actionButton,
    headerDivider = false,
    headerButton,
    headerRadioButton = false,
    headerRadioButtonTooltipProps = {},
    table = false,
    fullWidth = false,
    headerbackbtn = false,
    style = {},
    lockFeature = false,
    lockRole = false,
  } = props

  const renderHeaderButton = () => {
    if (lockFeature || lockRole) {
      return (
        <VmoTooltip
          content={lockFeature ? featureAccessDeniedContent : roleAccessDeniedContent}
          trigger={<VmoButton className="disabled-button" primary {...headerButton} />}
        />
      )
    }
    return <VmoButton primary {...headerButton} />
  }

  const renderHeaderRadioButton = () => {
    if (lockFeature || lockRole) {
      return (
        <VmoTooltip
          content={lockFeature ? featureAccessDeniedContent : roleAccessDeniedContent}
          trigger={
            <div>
              <AiFillLock className="mr-2" />
              <VmoRadio toggle {...headerRadioButton} disabled />
            </div>
          }
        />
      )
    }
    if (Object.keys(headerRadioButtonTooltipProps)?.length > 0) {
      return <VmoTooltip {...headerRadioButtonTooltipProps} trigger={<VmoRadio toggle {...headerRadioButton} />} />
    }
    return <VmoRadio toggle {...headerRadioButton} />
  }

  return (
    <>
      <div className="setHeader" style={style}>
        {header && (
          <>
            {headerbackbtn && (
              <VmoButton className="backBtn" {...headerbackbtn}>
                <FiChevronLeft /> Back
              </VmoButton>
            )}
            <div className="title">
              <div className="flex flex-justify-between flex-items-center" style={{width: '100%'}}>
                <div>
                  <h4>{header}</h4>
                  <div className="flex">
                    <p>{subHeader}</p>
                    {learnMoreUrl && (
                      <>
                        <a href={learnMoreUrl} className="learn-more">
                          <FiBookOpen />
                          Learn more
                        </a>
                      </>
                    )}
                  </div>
                </div>
                {/* {headerButton && <VmoButton primary {...headerButton} />} */}
                {headerButton && renderHeaderButton()}
                {/* {headerRadioButton && <VmoRadio toggle {...headerRadioButton} />} */}
                {headerRadioButton && renderHeaderRadioButton()}
              </div>
            </div>
          </>
        )}
      </div>
      {headerDivider && <VmoDivider style={{...(fullWidth ? {} : {maxWidth: '1140px'})}} />}
      <div className={table ? 'setTable' : fullWidth ? '' : 'setBodyContent'}>{props.children}</div>
      {actionButton && (
        <div className="setActionBtn">
          {actionButton.cancel && <VmoButton basic {...actionButton.cancel} />}
          {actionButton.success && (
            <LockPermissionTooltip isRoleAccessDenied={lockRole}>
              <VmoButton primary {...actionButton.success} className={lockRole ? 'disabled-button' : ''} />
            </LockPermissionTooltip>
          )}
        </div>
      )}
    </>
  )
}

export default Page
